import { apiTags } from "app/store/apiTags";
import { baseApi } from "../../app/baseApi";

const apiPrefix = 'subscription';
export const subscriptionApi = baseApi.injectEndpoints({
    reducerPath: 'subscriptionApi',
    endpoints: (builder) => ({
        subscription: builder.query({
            providesTags: [apiTags.SUBSCRIPTIONS],
            query: () => `${apiPrefix}/getsubscriptionsforemail`,
        }),
        getSubscriptionsForClient: builder.query({
            providesTags: [apiTags.CLIENT_SUBSCRIPTIONS],
            query: (clientId) => `${apiPrefix}/GetSubscriptionsForClient/${clientId}`,
        }),
        getEmailTypes: builder.query({
            providesTags: [apiTags.EMAIL_TYPES],
            query: () => `emailtypes`,
        }),
        updateSubscription: builder.mutation({
            query: subscription => ({
                url: `${apiPrefix}/addsubscription`,
                method: "POST",
                body: subscription
            }),
            invalidatesTags: [apiTags.SUBSCRIPTIONS, apiTags.CLIENT_SUBSCRIPTIONS],
        }),
        deleteSubscription: builder.mutation({
            query: subscription => ({
                url: `${apiPrefix}/deletesubscription`,
                method: "POST",
                body: subscription
            }),
            invalidatesTags: [apiTags.SUBSCRIPTIONS, apiTags.CLIENT_SUBSCRIPTIONS],
        }),
        deleteLotService: builder.mutation({
            query: (email) => ({
                url: `${apiPrefix}/deletelotservice`,
                method: "POST",
                body: { email }
            }),
            invalidatesTags: [apiTags.SUBSCRIPTIONS],
        })
    }),
});

export const { useSubscriptionQuery, useGetSubscriptionsForClientQuery, useGetEmailTypesQuery, useUpdateSubscriptionMutation, useDeleteSubscriptionMutation, useDeleteLotServiceMutation } = subscriptionApi;